import { useCallback } from 'react';

import { useEditionAwareness } from './edition-awareness-context';
import { useGetExperimentValue } from './experiment-context';
import { isEligibleForUserLimitDirectBuy } from './is-eligible-for-user-limit-direct-buy';

export const USER_LIMIT_DIRECT_BUY_EXPERIMENT = 'twcg-2318_ea_user_limit_direct_buy_experiment';

export function useUserLimitDirectBuyExperiment(): {
	expose: () => void;
} {
	const context = useEditionAwareness();
	const { getExperimentCohort } = useGetExperimentValue();

	const expose = useCallback(() => {
		if (!isEligibleForUserLimitDirectBuy(context)) {
			return;
		}
		getExperimentCohort(USER_LIMIT_DIRECT_BUY_EXPERIMENT);
	}, [context, getExperimentCohort]);

	return { expose };
}
